// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/root/workspace/jst-gyl_53Ms/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__RootLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/RootLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/404",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/root/workspace/jst-gyl_53Ms/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/video",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Open__Video' */'/root/workspace/jst-gyl_53Ms/src/pages/Open/Video'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/linkInvalid",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Open__LinkInvalid' */'/root/workspace/jst-gyl_53Ms/src/pages/Open/LinkInvalid'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/open",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "openGallery",
            "path": "/open/gallery/:spuId?/:type?",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Open__OpenGallery' */'/root/workspace/jst-gyl_53Ms/src/pages/Open/OpenGallery'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "redirect": "/404",
            "exact": true
          }
        ]
      },
      {
        "path": "/user",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "login",
            "path": "/user/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__Admin__Login' */'/root/workspace/jst-gyl_53Ms/src/pages/User/Admin/Login'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "bindAccount",
            "title": "绑定账号",
            "path": "/user/bindAccount",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__BindAccount' */'/root/workspace/jst-gyl_53Ms/src/pages/Account/BindAccount'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "callback",
            "title": "绑定",
            "path": "/user/callback",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Callback' */'/root/workspace/jst-gyl_53Ms/src/pages/Account/Callback'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "redirect": "/404",
            "exact": true
          }
        ]
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__AdminSecurityLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/AdminSecurityLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/business",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__AuthLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/AuthLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "businessApplication",
                "title": "招商报名详情",
                "path": "/business/application/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__BusinessApplication' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/BusinessApplication'), loading: LoadingComponent}),
                "authority": [
                  "/businessApplication"
                ],
                "exact": true
              },
              {
                "redirect": "/404",
                "exact": true
              }
            ]
          },
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicAdminLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/BasicAdminLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__AdminLayout' */'/root/workspace/jst-gyl_53Ms/src/layouts/AdminLayout'), loading: LoadingComponent}),
                "routes": [
                  {
                    "path": "/",
                    "redirect": "/",
                    "exact": true
                  },
                  {
                    "name": "supplierManage",
                    "title": "供应商管理",
                    "path": "/supplierManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__SupplierManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/SupplierManage'), loading: LoadingComponent}),
                    "authority": [
                      "/supplierManage"
                    ],
                    "group": "sellerManage",
                    "exact": true
                  },
                  {
                    "name": "selectCompany",
                    "title": "选商家",
                    "path": "/selectCompany",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__SelectCompany' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/SelectCompany'), loading: LoadingComponent}),
                    "authority": [
                      "/selectCompany"
                    ],
                    "group": "sellerManage",
                    "exact": true
                  },
                  {
                    "name": "selection",
                    "title": "选商品",
                    "path": "/selection",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__Selections' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/Selections'), loading: LoadingComponent}),
                    "authority": [
                      "/selection"
                    ],
                    "group": "sellerManage",
                    "exact": true
                  },
                  {
                    "name": "selectCategory",
                    "title": "选类目",
                    "path": "/selectCategory",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__SelectCategory' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/SelectCategory'), loading: LoadingComponent}),
                    "authority": [
                      "/selectCategory"
                    ],
                    "group": "sellerManage",
                    "exact": true
                  },
                  {
                    "name": "channelManage",
                    "title": "分销商管理",
                    "path": "/channelManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ChannelManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ChannelManage'), loading: LoadingComponent}),
                    "authority": [
                      "/channelManage"
                    ],
                    "group": "buyersManage",
                    "exact": true
                  },
                  {
                    "name": "selectChannel",
                    "title": "选分销商",
                    "path": "/selectChannel",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ChannelManage__SelectChannel' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ChannelManage/SelectChannel'), loading: LoadingComponent}),
                    "authority": [
                      "/selectChannel"
                    ],
                    "group": "buyersManage",
                    "exact": true
                  },
                  {
                    "name": "customerManage",
                    "title": "客户明细",
                    "path": "/customerManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__CustomerManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/CustomerManage'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "exact": true
                  },
                  {
                    "name": "customerManage/documentsDetail",
                    "title": "新增客户明细or编辑客户明细",
                    "path": "/customerManage/documentsDetail/:id?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__CustomerDetailInfo' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/CustomerDetailInfo'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "customerManage/sceneDocumentsDetail",
                    "title": "编辑客户场景",
                    "path": "/customerManage/sceneDocumentsDetail/:id?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__CustomerSceneDetail' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/CustomerSceneDetail'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "labelManage",
                    "title": "标签管理",
                    "path": "/labelManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__LabelManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/LabelManage'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "exact": true
                  },
                  {
                    "name": "businessProgress",
                    "title": "业务进展",
                    "path": "/businessProgress",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__BusinessProgress' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/BusinessProgress'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "exact": true
                  },
                  {
                    "name": "keyCustomers/analysis",
                    "title": "KA客户分析",
                    "path": "/keyCustomers/analysis",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__KeyCustomersAnalysis' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/KeyCustomersAnalysis'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "exact": true
                  },
                  {
                    "name": "potentialCustomersAnalysis",
                    "title": "潜在客户分析",
                    "path": "/potentialCustomersAnalysis",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__PotentialCustomersAnalysis' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/PotentialCustomersAnalysis'), loading: LoadingComponent}),
                    "group": "customerManage",
                    "authority": [
                      "/potentialCustomersAnalysis"
                    ],
                    "exact": true
                  },
                  {
                    "name": "tagsManageJht",
                    "title": "标签管理",
                    "path": "/tagsManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__TagsManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/TagsManage'), loading: LoadingComponent}),
                    "authority": [
                      "/tagsManageJht"
                    ],
                    "group": "sellerManage",
                    "exact": true
                  },
                  {
                    "name": "findCooperation/newbornZone",
                    "title": "爆款专区",
                    "path": "/findCooperation/newbornZone",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__index' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/index'), loading: LoadingComponent}),
                    "authority": [
                      "/findCooperation/newbornZone"
                    ],
                    "group": "findCooperation",
                    "exact": true
                  },
                  {
                    "name": "findCooperation/categoryAnalysis",
                    "title": "爆款专区类目分析",
                    "path": "/findCooperation/categoryAnalysis",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__CategoryAnalysis' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/CategoryAnalysis'), loading: LoadingComponent}),
                    "authority": [
                      "/findCooperation/categoryAnalysis"
                    ],
                    "group": "findCooperation",
                    "exact": true
                  },
                  {
                    "name": "findCooperation/activitySetting",
                    "title": "好商活动",
                    "path": "/findCooperation/activitySetting",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__ActivitySetting' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/ActivitySetting'), loading: LoadingComponent}),
                    "authority": [
                      "/findCooperation/activitySetting"
                    ],
                    "group": "findCooperation",
                    "exact": true
                  },
                  {
                    "name": "findCooperation/goodsSetting",
                    "title": "找商品",
                    "path": "/findCooperation/goodsSetting",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__GoodsSetting' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/GoodsSetting'), loading: LoadingComponent}),
                    "authority": [
                      "/findCooperation/goodsSetting"
                    ],
                    "group": "findCooperation",
                    "exact": true
                  },
                  {
                    "name": "findCooperation/baseSetting",
                    "title": "寻合作配置",
                    "path": "/findCooperation/baseSetting",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCooperationSetting__BaseSetting' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCooperationSetting/BaseSetting'), loading: LoadingComponent}),
                    "authority": [
                      "/findCooperation/baseSetting"
                    ],
                    "group": "findCooperation",
                    "exact": true
                  },
                  {
                    "name": "securityConfig",
                    "title": "系统配置",
                    "path": "/securityConfig",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__SecurityConfig' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/SecurityConfig'), loading: LoadingComponent}),
                    "authority": [
                      "/securityConfig"
                    ],
                    "group": "platformManage",
                    "exact": true
                  },
                  {
                    "name": "operationManage",
                    "title": "运营/BD人员",
                    "path": "/operationManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__OperationManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/OperationManage'), loading: LoadingComponent}),
                    "authority": [
                      "/operationManage"
                    ],
                    "group": "platformManage",
                    "exact": true
                  },
                  {
                    "name": "weChatRobotManage",
                    "title": "企微机器人管理",
                    "path": "/weChatRobotManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__WeChatRobotManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/WeChatRobotManage'), loading: LoadingComponent}),
                    "authority": [
                      "/weChatRobotManage"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "whatsWorthSelling",
                    "title": "什么值得卖",
                    "path": "/whatsWorthSelling",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__WhatsWorthSelling' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/WhatsWorthSelling'), loading: LoadingComponent}),
                    "authority": [
                      "/whatsWorthSelling"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "commodityMeeting",
                    "title": "首届聚货会",
                    "path": "/commodityMeeting",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__CommodityMeeting' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/CommodityMeeting'), loading: LoadingComponent}),
                    "authority": [
                      "/commodityMeeting"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "refundAudit",
                    "title": "店铺退款审核",
                    "path": "/refundAudit",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__RefundAudit' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/RefundAudit'), loading: LoadingComponent}),
                    "authority": [
                      "/refundAudit"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "advertising/positionManage",
                    "title": "广告位管理",
                    "path": "/advertising/positionManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__Advertising__PositionManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/Advertising/PositionManage'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "advertising/companyWatermarkIdentification",
                    "title": "商家识别",
                    "path": "/advertising/companyWatermarkIdentification",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__CompanyWatermarkIdentification' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/CompanyWatermarkIdentification'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "adsenseManage",
                    "title": "资源位管理",
                    "path": "/adsenseManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__AdsenseManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/AdsenseManage'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "classManage",
                    "title": "供应商类目管理",
                    "path": "/classManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__SupplierClassManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/SupplierClassManage'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "catPropMapping",
                    "title": "类目属性映射",
                    "path": "/catPropMapping",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__CatPropMapping' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/CatPropMapping'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "userFeedback",
                    "title": "用户反馈",
                    "path": "/userFeedback",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__AdminFeedback' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/AdminFeedback'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "linkGenerate",
                    "title": "链接生成器",
                    "path": "/linkGenerate",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__LinkGenerate' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/LinkGenerate'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "ffromList",
                    "title": "来源管理",
                    "path": "/ffromList",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FfromList' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FfromList'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "helpDocumentManage",
                    "title": "帮助文档管理",
                    "path": "/helpDocumentManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__HelpDocumentManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/HelpDocumentManage'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "activityManage",
                    "title": "分销活动管理",
                    "path": "/activityManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ActivityManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ActivityManage'), loading: LoadingComponent}),
                    "authority": [
                      "/activityManage"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "activityManage/activityBasicInfo",
                    "title": "基础信息",
                    "path": "/activityManage/activityBasicInfo",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ActivityBasicInfo' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ActivityBasicInfo'), loading: LoadingComponent}),
                    "authority": [
                      "/activityManage"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "activityManage/registedMerchant",
                    "title": "报名商家",
                    "path": "/activityManage/registedMerchant",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__RegistedMerchant' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/RegistedMerchant'), loading: LoadingComponent}),
                    "authority": [
                      "/activityManage"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "findCoopExemptReporting",
                    "title": "寻合作豁免分销商提报",
                    "path": "/findCoopExemptReporting",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FindCoopExemptReporting' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FindCoopExemptReporting'), loading: LoadingComponent}),
                    "authority": [
                      "/findCoopExemptReporting"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "versionCenter",
                    "title": "版本中心",
                    "path": "/versionCenter",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__VersionCenter' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/VersionCenter'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "exact": true
                  },
                  {
                    "name": "versionCenter/documentCenter",
                    "title": "文档中心",
                    "path": "/versionCenter/documentCenter/:id?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__VersionCenter__components__DocumentCenter' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/VersionCenter/components/DocumentCenter'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "versionCenter/resourceManage",
                    "title": "版本资源位管理",
                    "path": "/versionCenter/:versionKey?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__VersionCenter__components__ResourceManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/VersionCenter/components/ResourceManage'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "versionCenter/documentCenter/documentsDetail",
                    "title": "文档中心",
                    "path": "/versionCenter/documentCenter/documentsDetail/:id?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DocumentCenterDetail' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DocumentCenterDetail'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "documentCenter",
                    "title": "文档中心",
                    "path": "/documentCenter",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DocumentCenter' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DocumentCenter'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "exact": true
                  },
                  {
                    "name": "documentCenter/documentsDetail",
                    "title": "新增文档or编辑文档",
                    "path": "/documentCenter/documentsDetail/:id?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DocumentCenterDetail' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DocumentCenterDetail'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "helpDocumentManage/documentsDetail",
                    "title": "新增帮助or编辑帮助",
                    "path": "/helpDocumentManage/documentsDetail/:id?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DocumentsDetail' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DocumentsDetail'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "versionCenter/adsenseDetail",
                    "title": "创建资源位or编辑资源位 ",
                    "path": "/versionCenter/:versionKey/:formType?",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__AdsenseDetail' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/AdsenseDetail'), loading: LoadingComponent}),
                    "group": "businessHelpCenter",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "advertising/manage",
                    "title": "广告管理",
                    "path": "/advertising/manage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__Advertising__Manage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/Advertising/Manage'), loading: LoadingComponent}),
                    "group": "jhtBusinessManage",
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "merchantAccount",
                    "title": "商家网商账户",
                    "path": "/merchantAccount",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__MerchantAccount' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/MerchantAccount'), loading: LoadingComponent}),
                    "authority": [
                      "/merchantAccount"
                    ],
                    "group": "onlinePayManage",
                    "exact": true
                  },
                  {
                    "name": "paymentDetails",
                    "title": "支付单明细",
                    "path": "/paymentDetails",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__PaymentDetails' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/PaymentDetails'), loading: LoadingComponent}),
                    "authority": [
                      "/paymentDetails"
                    ],
                    "group": "onlinePayManage",
                    "exact": true
                  },
                  {
                    "name": "refundDetails",
                    "title": "退款单明细",
                    "path": "/refundDetails",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__RefundDetails' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/RefundDetails'), loading: LoadingComponent}),
                    "authority": [
                      "/refundDetails"
                    ],
                    "group": "onlinePayManage",
                    "exact": true
                  },
                  {
                    "name": "payRiskList",
                    "title": "支付预警",
                    "path": "/payRiskList",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__PayRiskList' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/PayRiskList'), loading: LoadingComponent}),
                    "authority": [
                      "/payRiskList"
                    ],
                    "group": "onlinePayManage",
                    "exact": true
                  },
                  {
                    "name": "paymentStatement",
                    "title": "在线支付对账单",
                    "path": "/paymentStatement",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__PaymentStatement' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/PaymentStatement'), loading: LoadingComponent}),
                    "authority": [
                      "/paymentStatement"
                    ],
                    "group": "onlinePayManage",
                    "exact": true
                  },
                  {
                    "name": "invoiceManagement",
                    "title": "发票管理",
                    "path": "/invoiceManagement",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__InvoiceManagement' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/InvoiceManagement'), loading: LoadingComponent}),
                    "authority": [
                      "/invoiceManagement"
                    ],
                    "group": "onlinePayManage",
                    "exact": true
                  },
                  {
                    "name": "serviceFeeAccountManagement",
                    "title": "分销服务费账户管理",
                    "path": "/serviceFeeAccountManagement",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ServiceFeeAccountManagement' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ServiceFeeAccountManagement'), loading: LoadingComponent}),
                    "authority": [
                      "/serviceFeeAccountManagement"
                    ],
                    "group": "commercializationManage",
                    "exact": true
                  },
                  {
                    "name": "serviceFeeAccountAnalysis",
                    "title": "分销服务费账户分析",
                    "path": "/serviceFeeAccountAnalysis",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ServiceFeeAccountAnalysis' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ServiceFeeAccountAnalysis'), loading: LoadingComponent}),
                    "group": "commercializationManage",
                    "exact": true
                  },
                  {
                    "name": "serviceFeeOrderManagement",
                    "title": "分销服务费单量明细",
                    "path": "/serviceFeeOrderManagement",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__ServiceFeeOrderManagement' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/ServiceFeeOrderManagement'), loading: LoadingComponent}),
                    "authority": [
                      "/serviceFeeOrderManagement"
                    ],
                    "group": "commercializationManage",
                    "exact": true
                  },
                  {
                    "name": "serviceFeeBillList",
                    "title": "分销服务费对账单",
                    "path": "/serviceFeeBillList",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__serviceFeeBillList' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/serviceFeeBillList'), loading: LoadingComponent}),
                    "authority": [
                      "/serviceFeeBillList"
                    ],
                    "group": "commercializationManage",
                    "exact": true
                  },
                  {
                    "name": "jrpaMachine",
                    "title": "云服务机器",
                    "path": "/jrpaMachine",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__JRPA__Machine' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/JRPA/Machine'), loading: LoadingComponent}),
                    "authority": [
                      "/jrpaMachine"
                    ],
                    "group": "JRPA",
                    "exact": true
                  },
                  {
                    "name": "jrpaTask",
                    "title": "云服务任务",
                    "path": "/jrpaTask",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__JRPA__Task' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/JRPA/Task'), loading: LoadingComponent}),
                    "authority": [
                      "/jrpaTask"
                    ],
                    "group": "JRPA",
                    "exact": true
                  },
                  {
                    "name": "partnerPromoteInfo",
                    "title": "合伙人推广明细",
                    "path": "/partnerPromoteInfo",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__PartnerPromoteInfo' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/PartnerPromoteInfo'), loading: LoadingComponent}),
                    "authority": [
                      "/partnerPromoteInfo"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "afterSalesAddressAnalysis",
                    "title": "售后地址使用分析",
                    "path": "/afterSalesAddressAnalysis",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__AfterSalesAddressAnalysis' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/AfterSalesAddressAnalysis'), loading: LoadingComponent}),
                    "authority": [
                      "/afterSalesAddressAnalysis"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "onlineGoodsLinkAnalysis",
                    "title": "检测工具使用分析",
                    "path": "/onlineGoodsLinkAnalysis",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__OnlineGoodsLinkAnalysis' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/OnlineGoodsLinkAnalysis'), loading: LoadingComponent}),
                    "authority": [
                      "/onlineGoodsLinkAnalysis"
                    ],
                    "group": "jhtBusinessManage",
                    "exact": true
                  },
                  {
                    "name": "darenBusinessDashboard",
                    "title": "达人业务看板",
                    "path": "/darenBusinessDashboard",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DarenBusinessDashboard' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DarenBusinessDashboard'), loading: LoadingComponent}),
                    "authority": [
                      "/darenBusinessDashboard"
                    ],
                    "group": "distributeManage",
                    "exact": true
                  },
                  {
                    "name": "darenCooperationStatistics",
                    "title": "联盟商家管理",
                    "path": "/darenCooperationStatistics",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DarenCoopStatistics' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DarenCoopStatistics'), loading: LoadingComponent}),
                    "authority": [
                      "/darenCooperationStatistics"
                    ],
                    "group": "distributeManage",
                    "exact": true
                  },
                  {
                    "name": "darenAllianceManagement",
                    "title": "联盟达人管理",
                    "path": "/darenAllianceManagement",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__DarenAllianceManagement' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/DarenAllianceManagement'), loading: LoadingComponent}),
                    "authority": [
                      "/darenAllianceManagement"
                    ],
                    "group": "distributeManage",
                    "exact": true
                  },
                  {
                    "name": "failReasonManage",
                    "title": "失败原因管理工具",
                    "path": "/failReasonManage",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin__FailReasonManage' */'/root/workspace/jst-gyl_53Ms/src/pages/Admin/FailReasonManage'), loading: LoadingComponent}),
                    "authority": [
                      "/failReasonManage"
                    ],
                    "group": "productConfig",
                    "exact": true
                  },
                  {
                    "redirect": "/404",
                    "exact": true
                  }
                ]
              },
              {
                "redirect": "/404",
                "exact": true
              }
            ]
          },
          {
            "redirect": "/404",
            "exact": true
          }
        ]
      },
      {
        "redirect": "/404",
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/root/workspace/jst-gyl_53Ms/src/pages/404'), loading: LoadingComponent})
      }
    ]
  },
  {
    "redirect": "/404",
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
